import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

const chartBlock = {
  init(): void {
    gsap.registerPlugin(ScrollTrigger)

    document.querySelectorAll<HTMLElement>('.chart-block__embed').forEach((target: HTMLElement) => {
      this.handleChartBlock(target)
    })

    // Using the same for Embeds Block in Annual Report

    document.querySelectorAll<HTMLElement>('.embed-item__embed').forEach((target: HTMLElement) => {
      this.handleChartBlock(target)
    })

    // Handling responsiveness of iframes for fixed iframe embeds

    document.querySelectorAll<HTMLElement>('.main-ar .embed-item__embed').forEach((target: HTMLElement) => {
      this.handleIframeResponsiveness(target)
    })
  },

  handleIframeResponsiveness(target): void {
    const iframe = target.querySelector('iframe')
    const width = iframe?.getAttribute('width')
    const height = iframe?.getAttribute('height')

    if (width && height) {
      gsap.to(iframe, {
        aspectRatio: `${width} / ${height}`,
        duration: 0.01,
        height: 'auto',
        onComplete: () => {
          ScrollTrigger.getAll().forEach((trigger) => trigger.refresh())
        },
        width: '100%',
      })
    }
  },

  handleChartBlock(target): void {
    const method = {
      init(): void {
        const observer = new IntersectionObserver(
          (entries, observerInstance) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const iframe = target.querySelector('iframe')

                if (iframe) {
                  method.pollIframeHeight(iframe)
                }

                observerInstance.unobserve(target)
              }
            })
          },
          {
            root: null,
            rootMargin: '0px',
            threshold: 0,
          }
        )

        observer.observe(target)

        // console.log('Chart block initialized')
      },

      pollIframeHeight(iframe): void {
        let lastHeight = 0
        let stableCounter = 0
        const maxStableChecks = 10
        const intervalTime = 50

        const interval = setInterval(() => {
          const currentHeight = iframe.offsetHeight

          if (currentHeight !== lastHeight) {
            stableCounter = 0
            lastHeight = currentHeight
          } else {
            stableCounter += 1
          }

          if (stableCounter >= maxStableChecks) {
            clearInterval(interval)

            // console.log(`Final iframe height: ${currentHeight}px`)

            setTimeout(() => {
              ScrollTrigger.getAll().forEach((trigger) => trigger.refresh())
            }, 123)
          }
        }, intervalTime)
      },
    }

    method.init()
  },
}

export default chartBlock
